import axios from "axios";
import { setToast } from "../../util/toast";
import * as ActionType from "./hostRequest.type";
import { apiInstanceFetch } from "../../util/api";

// get host request
export const getHostRequest = () => (dispatch) => {
  apiInstanceFetch
    .get("request/newRequest")
    .then((res) => {
      dispatch({
        type: ActionType.GET_HOST_REQUEST,

        payload: res.requestAll,
      });
    })
    .catch((error) => console.log("error", error));
};

// edit request
export const hostRequestUpdate = (fromData, id) => (dispatch) => {
 
  axios
    .patch(`request/${id}`, fromData)
    .then((res) => {

      if (res.data.status) {
        setToast("success", "Update Successfully!");
        dispatch({
          type: ActionType.EDIT_HOST_REQUEST,
          payload: { editHost: res.data.request, id },
        });
      } else {
     
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      console.log('first', error.response.data.message)
     
      setToast("error", error.response.data.message);
    });
};

// host Request accept (agencyId verilirse yayinci dogrudan o ajansa baglanir)
export const hostRequestAccept = (id, agencyId) => (dispatch) => {
  axios
    .put(`request/${id}`, agencyId ? { agencyId } : {})
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.ACCEPT_HOST_REQUEST, payload: id });
        setToast("success", "Başvuru onaylandı, kullanıcıya bildirim gitti.");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error?.response?.data?.message || "İşlem başarısız"));
};

// basvuruyu reddet: kullaniciya kendi dilinde bildirim gider
export const hostRequestDecline = (id, reason) => (dispatch) => {
  axios
    .post(`request/${id}/decline`, { reason: reason || "" })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DECLINE_HOST_REQUEST, payload: { id, request: res.data.request } });
        setToast("success", "Başvuru reddedildi, kullanıcıya bildirim gitti.");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error?.response?.data?.message || "İşlem başarısız"));
};

// onay ekranindaki ajans listesi
export const getAgencyOptions = () => (dispatch) => {
  apiInstanceFetch
    .get("request/agencyOptions")
    .then((res) => {
      if (res.status) dispatch({ type: ActionType.GET_AGENCY_OPTIONS, payload: res.agencies || [] });
    })
    .catch((error) => console.log("error", error));
};
